<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Keep size when switching colors
document.addEventListener("DOMContentLoaded", function () {
  const colorLinks = document.querySelectorAll(".color-siblings a");

  colorLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const sizeSelector = document.querySelector(
        'input[name="Size"]:checked'
      );
      const selectedSize = sizeSelector ? sizeSelector.value : "";

      let url = new URL(this.href);
      if (selectedSize) {
        url.searchParams.set("size", selectedSize);
      }

      window.location.href = url.toString();
    });
  });
});
